module.exports = __webpack_public_path__ + "static/media/java.3dd9ee6c.png";